import React from 'react';
import { SearchResult } from '@teetsh/app/src/containers/Search/types';
import tw, { css } from 'twin.macro';
import { useTranslation } from 'react-i18next';

interface Props {
  result: SearchResult;
  value?: string;
  onChange: (v?: string) => void;
}

function FilterButton(props: {
  label: string;
  value: string;
  size: number;
  active: boolean;
  onClick: (v) => void;
}) {
  const { label, size, active, onClick, value } = props;

  return (
    <span
      onClick={() => onClick(value)}
      tw="m-1 flex rounded-full border border-neutral-quiet items-baseline pb-1.5 pt-1 pl-3 pr-2 text-sm font-medium bg-white text-neutral-intense cursor-pointer"
      css={[
        active && tw`bg-brand-intense text-white! border-brand-intense`,
        !active && tw`bg-white text-muted`,
        size > 0 && !active && tw`text-neutral-intense`,
      ]}
    >
      <span
        css={[
          tw`truncate`,
          css`
            max-width: 8rem;
          `,
        ]}
      >
        <span tw="text-xs mr-1">{label}</span>
      </span>
      <span
        css={[
          size === 0 && tw`bg-neutral-supershy text-neutral-supershy`,
          size > 0 && tw`bg-brand-quiet text-neutral-moderate`,
          tw`ml-1.5 rounded py-0.5 px-1.5 text-xs font-semibold tabular-nums `,
        ]}
      >
        {size}
      </span>
    </span>
  );
}

export function FilterBar(props: Props) {
  const { result, value, onChange } = props;
  const { t } = useTranslation(['common']);

  if (!result) {
    return null;
  }
  return (
    <div tw="inline-flex flex-wrap gap-0.5 px-2">
      {Object.entries(result).map(
        ([key, items]: [key: keyof SearchResult, items: any]) => {
          if (key === 'isEmpty') {
            return null;
          }

          return (
            <FilterButton
              key={key}
              value={key}
              active={value === key}
              label={t(`common:search.filters.${key}`)}
              size={(items || []).length}
              onClick={() =>
                onChange(value === key ? undefined : (key as 'seances'))
              }
            />
          );
        },
      )}
    </div>
  );
}
